<nf-grid-wrapper
  data-testid="ice-grid-container"
  [attr.aria-busy]="loading"
  [hideSearch]="true"
  [hideClearAll]="true"
>
  <nf-grid-wrapper-header-left class="ice-actions-title">
    <h2 class="title">ICE Corporate Actions</h2>
    <ng-select
      data-testid="client-select"
      [items]="clients"
      [multiple]="true"
      [virtualScroll]="true"
      bindLabel="name"
      bindValue="id"
      [searchFn]="clientSearchFn"
      [ngModel]="selectedClientIds"
      (ngModelChange)="onSelectedClientIdsChange($event)"
      placeholder="Select Client(s)"
      [closeOnSelect]="false"
      class="client-select"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ item.name }} ({{ item.id }})
      </ng-template>
    </ng-select>
    <button
      data-testid="load-actions-btn"
      (click)="loadCorporateActions()"
      class="btn btn-sm btn-primary"
      [disabled]="loading || selectedClientIds.length === 0"
    >
      Load
    </button>
    <nf-daterange
      [ngModel]="dateRange"
      (ngModelChange)="onDateRangeChange($event)"
      [beginDateRequired]="true"
      [endDateRequired]="true"
    ></nf-daterange>
    <span
      *ngIf="showLookbackWarning"
      data-testid="lookback-warning"
      class="lookback-warning text-warning"
      [ngbTooltip]="
        'Position discovery only goes back ' +
        lookbackDays +
        ' days. Events tied to holdings closed before ' +
        lookbackCutoff +
        ' will not be surfaced.'
      "
      placement="bottom"
    >
      <span class="mdi mdi-alert-circle"></span>
      Position lookback capped at {{ lookbackDays }} days
    </span>
  </nf-grid-wrapper-header-left>
  <nf-grid-wrapper-content>
    <hs-loader [class.active]="loading" [loading]="loading"></hs-loader>
    <nf-table-layout
      [hideTitle]="true"
      [gridOptions]="gridOptions"
      [data]="rowData"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
